<template>
  <div id="login">
    <v-container>
      <img class="fed-logo" src="../assets/fed.png" />
      <v-layout row>
        <v-flex xs12 sm4 offset-sm4>
          <v-card>
            <div class="login-form">
              <v-text-field
                name="email"
                label="Email"
                id="email"
                v-model="email"
              ></v-text-field>
              <v-text-field
                name="input-10-1"
                label="Enter your password"
                hint="At least 8 characters"
                v-model="password"
                min="8"
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                counter
              ></v-text-field>
              <v-btn v-on:click="signIn" flat outline :loading="loading">Log In</v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';

  export default {
    name: 'login',
    data: function(){
      return {
        email: '',
        password: '',
        e1: true,
        loading: false

      };
    },
    mounted () {
      let self = this;
      // this.$store.commit('userInfo', null);
      window.addEventListener('keyup', this.listener, {once: true});
    },
    methods: {
      signIn: function() {
        this.loading = true;
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          async (user) => {
            window.removeEventListener('keyup', this.listener, {once: true});
            this.$router.push({name: 'Index'});
          },
          (err) => {
            alert(err);
          }
        )
      },
      listener: function(event){
        if (event.keyCode === 13) {
          this.signIn();
        }
      }
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  #login {
    text-align: center;

    .login-form{
      margin: 20px;
      padding: 20px;
    }
    .fed-logo{
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue